import { useTranslation } from "react-i18next";
import { useAreaCrumbs } from "@/components/areaCrumbs";
import { PageBreadcrumbs } from "@/components/PageBreadcrumbs";
import { FlowForm } from "./FlowForm";

/** /build/workflows/new — details form; creating lands on the Steps tab to build. */
export function NewFlowPage() {
  const { t } = useTranslation("workflows");
  const areas = useAreaCrumbs();
  return (
    <div className="flex flex-col">
      <PageBreadcrumbs
        trail={[areas.build, { label: t("title"), to: "/build/workflows" }]}
        current={t("form.create")}
      />
      <div className="mx-auto flex w-full max-w-3xl flex-col gap-6 px-4 py-6 md:px-8">
        <FlowForm />
      </div>
    </div>
  );
}
